import gqlClient from '@discover-data/gql/client';
import isNonNull from '@discover-lib/isNonNull';
import { cuisineOptions, type CuisineOption } from '@/lib/cityCuisine';
import CityCuisinesQuery from './cityCuisinesQuery';

export type CityCuisine = CuisineOption & {
  imagePath: string | null;
};

export default async function getCityCuisines({
  cityId,
  abortSignal,
}: {
  cityId: number;
  abortSignal?: AbortSignal;
}): Promise<CityCuisine[]> {
  const { City: city } = await gqlClient({
    query: CityCuisinesQuery,
    variables: { id: cityId },
    abortSignal,
  });

  // allCuisines is alphabetical and leads with sparse cuisines. popularCuisines is that city's ranked subset.
  const nodes = (city?.popularCuisines?.nodes ?? []).filter((node) =>
    isNonNull(node, ['id', 'title'])
  );
  const imageById = new Map(nodes.map((node) => [node.id, node.image?.basePath ?? null]));

  return cuisineOptions(nodes).map((cuisine) => ({
    ...cuisine,
    imagePath: imageById.get(cuisine.id) ?? null,
  }));
}
